import React from 'react';
import ReportTableBody from './ReportTableBody';
import { PRODUCTS } from '../config/columns.config';
import { useTheme } from '@mui/material/styles';

const SalesReportTable = (props) => {
  const theme = useTheme();

  return (
    <table className="w-full text-sm border-collapse table-fixed" style={{ color: theme.palette.text.primary }}>
      <colgroup>
        <col className="w-64" />
        {PRODUCTS.map(p => <col key={p.key} className="w-24" />)}
        <col className="w-24" />
        <col className="w-24" />
        <col className="w-24" />
        <col className="w-24" />
      </colgroup>
      <ReportTableBody {...props} />
    </table>
  );
};

export default SalesReportTable;